import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const openAutouploadSuccessDialog = () => openPopupHelper({ popupName: popupNames.AUTOUPLOAD_PROMO_SUCCESS });
